'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import {
  DEFAULT_LIFECYCLE_STATE_FILTER,
  LifecycleStateFilterSchema,
  type LifecycleStateFilterDto,
} from '@terra/shared-dto-types';
import { Filter } from '../../components/filter';

export type LifecycleFilterProps = {
  value?: LifecycleStateFilterDto;
  onValueChange: (lifecycleState: LifecycleStateFilterDto) => void;
};

export function LifecycleFilter({
  value = DEFAULT_LIFECYCLE_STATE_FILTER,
  onValueChange,
}: LifecycleFilterProps) {
  const t = useTranslations('designSystem.common');
  const tListPage = useTranslations('designSystem.listPage');
  const items = useMemo(
    () => [
      { value: 'active', label: t('active') },
      { value: 'archived', label: t('archived') },
    ],
    [t],
  );
  const selectedValue = value === DEFAULT_LIFECYCLE_STATE_FILTER ? [] : [value];

  return (
    <Filter
      id="lifecycle"
      density="compact"
      placeholder={tListPage('lifecycle')}
      items={items}
      value={selectedValue}
      onChange={(values) => {
        if (values.length === 0) {
          onValueChange(DEFAULT_LIFECYCLE_STATE_FILTER);

          return;
        }

        const parsed = LifecycleStateFilterSchema.safeParse(values[0]);

        if (parsed.success && parsed.data !== DEFAULT_LIFECYCLE_STATE_FILTER) {
          onValueChange(parsed.data);
        }
      }}
    />
  );
}
